import React from 'react';
import { Card, Box, CircularProgress, Alert } from '@mui/material';
import { VideoPlayer } from '../../../VideoPlayer';

/**
 * VideoPreview - plays video files (mp4, webm, mkv …) in the preview sidebar
 */
export const VideoPreview = ({ file, imageUrl, loading, error }) => (
  <Card sx={{ bgcolor: '#000', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
    {loading && (
      <Box display="flex" justifyContent="center" alignItems="center" sx={{ minHeight: 200 }}>
        <CircularProgress />
      </Box>
    )}
    {error && (
      <Alert severity="error" sx={{ m: 2 }}>
        {error}
      </Alert>
    )}
    {imageUrl && !loading && (
      <VideoPlayer src={imageUrl} title={file.filename} style={{ width: '100%' }} />
    )}
  </Card>
);
